import {useAppDispatch} from '../../hooks/redux'
import {closeModal} from '../../redux/features/modal'

import {ModalMeta} from '../../types'

import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'
import Paragraph from '../../../../commons/src/components/paragraph'

type Props = {
  meta: ModalMeta
  onConfirm: () => void
}

const ConfirmDeleteMessageModal = ({meta, onConfirm}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label="Please confirm deletion" size="l" />}
      onClose={() => dispatch(closeModal())}
      buttons={
        <>
          <Button hierarchy="ghost" onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
          <Button
            appearance="error"
            onClick={() => {
              onConfirm()
              dispatch(closeModal())
            }}
          >
            Proceed
          </Button>
        </>
      }
    >
      <Paragraph>
        Your current message will be deleted when you select a different template. Are you sure you
        want to continue?
      </Paragraph>
    </Modal>
  )
}

export default ConfirmDeleteMessageModal
